export enum UserType {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  REGULATOR = 'regulator',
  COMPANY = 'company',
  CUSTOMER = 'customer'
}

export const isUserType = (userType: string, type: UserType): boolean => userType === type;
